import { Component, OnInit, Input } from '@angular/core';
import { EmailService } from 'src/app/services/integrations/email/email.service';

@Component({
  selector: 'app-email-feed-item',
  templateUrl: './email-feed-item.component.html',
  styleUrls: ['./email-feed-item.component.css']
})
export class EmailFeedItemComponent implements OnInit {

  /** Props */
  @Input() message: any;

  constructor(
    private emailService: EmailService,
  ) { }

  ngOnInit() {
  }

  reply() {
    this.emailService.emailToActOn.next({ ...this.message, type: 'reply' });
  }

  viewMessage() {
    this.emailService.emailToActOn.next({ ...this.message, type: 'view' });
  }

}
